import {
  Component,
  Element,
  Event,
  EventEmitter,
  h,
  Host,
  JSX,
  State,
} from "@stencil/core";
import { componentsOnReady } from "@phn/utility/ready";
import { Timeout } from "@phn/utility/timeout";
import { navContentStore } from "@phn/state/nav-content-store";
import { getConfig } from "@phn/utility/helper";
import { navStateStore } from "@phn/state/nav-state-store";
import featureToggles from "@phn/services/feature-toggles";
import windowService from "@phn/services/window-service";
import { logout } from "@phn/services/user-service";
import {
  PHN_AUTH_EVENT,
  dispatchAuthEvent,
} from "@phn/services/auth-event.service";
import Links from "./myporsche-drawer-links";
import Login from "./myporsche-drawer-login";

@Component({
  tag: "phn-nd-myporsche-drawer",
  styleUrl: "myporsche-drawer.scss",
  scoped: true,
})
export class MyPorscheDrawer {
  @State() showSkeleton = !navStateStore.state.myPorscheLoaded;

  @Element() el!: HTMLPhnNdMyporscheDrawerElement;

  @Event({ composed: true, bubbles: true, cancelable: true })
  phnLogout!: EventEmitter<void>;

  private eventPreventedTimeout = new Timeout(0);

  private async waitForComponentsToLoad() {
    await componentsOnReady(this.el, new Timeout(5000));
    this.showSkeleton = false;
  }

  componentDidRender() {
    navStateStore.state.myPorscheLoaded = true;
  }

  handleLogout() {
    const config = getConfig(navStateStore.state.env);

    const phnLogout = this.phnLogout.emit();

    this.eventPreventedTimeout.set(() => {
      if (phnLogout.defaultPrevented) {
        dispatchAuthEvent({ eventType: PHN_AUTH_EVENT.LOGOUT_DEFAULT_PREVENTED });
        return;
      }

      const returnUrl =
        windowService.location?.origin ||
        `${config.IDENTITY_PROVIDER_URL}/v2/logout`;

      const logoutUrl = `${config.IDENTITY_PROVIDER_URL}/v2/logout?client_id=${config.IDENTITY_CLIENT_ID}&returnTo=${returnUrl}`;

      if (featureToggles.isSeamlessLoginEnabled()) {
        logout(config);
      } else {
        dispatchAuthEvent({ eventType: PHN_AUTH_EVENT.LEGACY_LOGOUT });
        windowService.redirectToUrl(logoutUrl);
      }

      return;
    });
  }

  componentWillLoad(): void {
    this.waitForComponentsToLoad();
  }

  render(): JSX.Element | null {
    const { myPorsche } = navContentStore.state;

    if (!myPorsche) return null;

    return (
      <Host class={this.showSkeleton ? "skeleton" : ""}>
        <div class="phn-flex-col phn-justify-around">
          <Login content={myPorsche} showSkeleton={this.showSkeleton} />
          <Links
            content={myPorsche}
            onLogoutClick={() => this.handleLogout()}
            showSkeleton={this.showSkeleton}
          />
        </div>
      </Host>
    );
  }
}
